// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion[data-v-242b8576] {\n  --magic-accordion-toggle-background: var(--magic-tertiary, #311261);\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
